import React from 'react';
import { Helmet } from 'react-helmet-async';
import { AddCircle, Build, BugReport, Launch, ArrowUpward } from '@mui/icons-material';
import { changelog } from '../data/changelog';

const Changelog = () => {
    const getChangeIcon = (type) => {
        switch (type) {
            case 'added':
                return <AddCircle fontSize="small" className="text-green-600" />;
            case 'improved':
                return <ArrowUpward fontSize="small" className="text-blue-600" />;
            case 'fixed':
                return <BugReport fontSize="small" className="text-purple-600" />;
            default:
                return <Build fontSize="small" className="text-gray-600" />;
        }
    };

    const getChangeLabel = (type) => {
        switch (type) {
            case 'added':
                return 'Ajouté';
            case 'improved':
                return 'Amélioré';
            case 'fixed':
                return 'Corrigé';
            default:
                return 'Modifié';
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    };

    return (
        <>
            <Helmet>
                <title>Changelog - Netikash Developer Portal</title>
                <meta name="description" content="Historique des changements de l'API Netikash : nouvelles fonctionnalités, améliorations et corrections." />
            </Helmet>
            <div className="min-h-screen bg-gray-50 dark:bg-slate-950 dark:text-slate-100 pt-16">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Changelog</h1>
                    <p className="text-gray-600">
                        Découvrez les dernières mises à jour, nouvelles fonctionnalités et corrections de l'API Netikash.
                    </p>
                </div>

                {/* Changelog Items */}
                <div className="space-y-6">
                    {changelog.map((item, index) => (
                        <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                            <div className="p-6 border-b border-gray-200">
                                <div className="flex items-start justify-between">
                                    <div>
                                        <div className="flex items-center space-x-3 mb-2">
                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-amber-100 text-amber-800">
                                                {item.version}
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                {formatDate(item.date)}
                                            </span>
                                        </div>
                                        <h2 className="text-xl font-semibold text-gray-900">
                                            {item.title}
                                        </h2>
                                    </div>
                                    {item.type === 'release' && (
                                        <div className="flex items-center space-x-1 text-amber-600">
                                            <Launch fontSize="small" />
                                            <span className="text-sm font-medium">Release</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="p-6">
                                <ul className="space-y-3">
                                    {item.changes.map((change, changeIndex) => (
                                        <li key={changeIndex} className="flex items-start space-x-3">
                                            <div className="mt-0.5">
                                                {getChangeIcon(change.type)}
                                            </div>
                                            <div className="flex-1">
                                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700 mr-2">
                                                    {getChangeLabel(change.type)}
                                                </span>
                                                <span className="text-gray-700">{change.description}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="mt-12 text-center text-gray-500 text-sm">
                    <p>Pour plus d'informations, consultez la <a href="/documentation" className="text-amber-600 hover:underline">documentation complète</a>.</p>
                </div>
            </div>
            </div>
        </>
    );
};

export default Changelog;
